function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { faChevronDown, faCircle, faHammer, faSignOut } from '@fortawesome/free-solid-svg-icons';
import { joinChannel, joinChannelAddModerator, partChannel } from '@/actions/ChannelActions';
import OnboardingModal from '../OnboardingModal';
import { FormattedMessage } from 'react-intl';
import { Button, Menu } from '@mantine/core';
import Icon, { IconSizes } from '../Icon';
import styles from './StatusMenu.module.scss';
import { useDisclosure } from '@mantine/hooks';
function StatusMenu(_param) {
    var channel = _param.channel, props = _object_without_properties(_param, [
        "channel"
    ]);
    var _React_useState = _sliced_to_array(React.useState(false), 2), loading = _React_useState[0], setLoading = _React_useState[1];
    var hasJoined = channel === null || channel === void 0 ? void 0 : channel.joined;
    var _useDisclosure = _sliced_to_array(useDisclosure(), 2), onboardingMenuOpen = _useDisclosure[0], onboardingMenuHandlers = _useDisclosure[1];
    var toggleChannel = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var _ref, addedModerator;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        ,
                        5,
                        6
                    ]);
                    setLoading(true);
                    if (!hasJoined) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        partChannel(channel._id)
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        Promise.allSettled([
                            joinChannelAddModerator(channel._id),
                            joinChannel(channel._id)
                        ])
                    ];
                case 3:
                    _ref = _sliced_to_array.apply(void 0, [
                        _state.sent(),
                        1
                    ]), addedModerator = _ref[0];
                    if (addedModerator.status === 'fulfilled' && !addedModerator.value) {
                        onboardingMenuHandlers.open();
                    }
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    setLoading(false);
                    return [
                        7
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    }), [
        channel._id,
        hasJoined,
        onboardingMenuHandlers
    ]);
    if (!hasJoined) {
        return /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
            loading: loading,
            variant: "inverse",
            onClick: toggleChannel
        }, props), {
            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                id: "t+Wf41",
                defaultMessage: "Join Channel"
            })
        }));
    }
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx(OnboardingModal, {
                channel: channel,
                isOpen: onboardingMenuOpen,
                onClose: onboardingMenuHandlers.close
            }),
            /*#__PURE__*/ _jsxs(Menu, {
                shadow: "md",
                position: "bottom-end",
                children: [
                    /*#__PURE__*/ _jsx(Menu.Target, {
                        children: /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
                            loading: loading,
                            rightSection: /*#__PURE__*/ _jsx(Icon, {
                                size: IconSizes.XS,
                                icon: faChevronDown
                            }),
                            leftSection: /*#__PURE__*/ _jsx(Icon, {
                                className: styles.statusIcon,
                                size: IconSizes.XS,
                                icon: faCircle
                            })
                        }, props), {
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "F52rcw",
                                defaultMessage: "Nightbot Online"
                            })
                        }))
                    }),
                    /*#__PURE__*/ _jsxs(Menu.Dropdown, {
                        className: styles.dropdown,
                        children: [
                            /*#__PURE__*/ _jsx(Menu.Item, {
                                onClick: onboardingMenuHandlers.open,
                                leftSection: /*#__PURE__*/ _jsx(Icon, {
                                    size: IconSizes.SM,
                                    icon: faHammer
                                }),
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "wyHWi7",
                                    defaultMessage: "Setting Up"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Menu.Item, {
                                color: "red",
                                onClick: toggleChannel,
                                leftSection: /*#__PURE__*/ _jsx(Icon, {
                                    size: IconSizes.SM,
                                    icon: faSignOut
                                }),
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "zp3bBg",
                                    defaultMessage: "Leave Channel"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
export default StatusMenu;
